import { HERO_COVER, HERO_FEATURE } from "@/mocks/home";
import Reveal from "./Reveal";

const STATS = [
  { value: "12.8k", label: "本周收录热帖", accent: false },
  { value: "1.6k", label: "论坛爆料速递", accent: true },
  { value: "3.2k", label: "神贴仓库存量", accent: false },
];

export default function Hero() {
  return (
    <section id="top" className="w-full">
      <div className="mx-auto max-w-7xl px-4 py-8 md:px-6 md:py-12">
        <div className="grid grid-cols-1 items-stretch gap-6 lg:grid-cols-2 lg:gap-8">
          {/* 左：文 */}
          <Reveal className="flex flex-col justify-center">
            <div className="inline-flex w-fit items-center gap-2 rounded-full bg-primary-50 px-3 py-1.5 text-xs font-bold text-primary-600">
              <i className="ri-fire-fill text-sm text-primary-500" />
              {HERO_FEATURE.kicker}
            </div>

            <h1 className="editorial-title mt-5 text-[26px] font-black leading-[1.32] text-foreground-950 md:text-[38px]">
              {HERO_FEATURE.title}
            </h1>

            <div className="mt-5 flex items-center gap-2 text-xs font-bold tracking-wide text-accent-700">
              <i className="ri-double-quotes-l text-base" />
              天涯海角各路瓜，点开即达讨论现场
            </div>

            <p className="mt-3 max-w-xl text-sm leading-[1.9] text-foreground-600 md:text-[15px]">
              {HERO_FEATURE.excerpt}
            </p>

            <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">
              <span className="flex items-center gap-1.5">
                <i className="ri-flashlight-fill text-accent-600" />
                {HERO_FEATURE.meta}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line" />
                今日 08:30 更新
              </span>
            </div>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <a
                href="#god"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
              >
                去读今日封面
                <i className="ri-arrow-right-line" />
              </a>
              <a
                href="#hot"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-950/15 px-6 py-3 text-sm font-bold text-foreground-800 transition-colors hover:bg-secondary-100"
              >
                先看热榜
              </a>
            </div>
          </Reveal>

          {/* 右：图对开 */}
          <Reveal delay={120} className="relative">
            <div className="relative h-full min-h-[360px] overflow-hidden rounded-lg md:min-h-[480px]">
              <img
                src={HERO_COVER}
                alt="海角网今日封面 · 天涯热帖与论坛爆料精选"
                title="海角网天涯热帖今日封面"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-black/10" />
              <div className="absolute left-4 top-4 rounded-md bg-background-50/95 px-3 py-1.5 text-[11px] font-black tracking-[0.14em] text-primary-600 shadow-sm">
                HAOJIAO DAILY · 每日上新
              </div>
            </div>

            <div className="absolute -bottom-5 right-4 hidden w-52 rounded-md border border-background-200 bg-background-50 p-4 md:block">
              <p className="text-[11px] font-bold uppercase tracking-wider text-foreground-500">本周讨论热度</p>
              <p className="mt-1 font-heading text-3xl font-black text-accent-600">92,408</p>
              <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-secondary-100">
                <div className="h-full w-[82%] rounded-full bg-accent-500" />
              </div>
              <p className="mt-2 text-[11px] text-foreground-500">较上周 +18%</p>
            </div>
          </Reveal>
        </div>

        {/* 数据条 */}
        <Reveal delay={80}>
          <div className="mt-8 grid grid-cols-1 gap-4 border-t border-background-200 pt-6 sm:grid-cols-3 md:mt-10">
            {STATS.map((s) => (
              <div key={s.label} className="flex items-center gap-3">
                <span
                  className={`font-heading text-2xl font-black md:text-3xl ${
                    s.accent ? "text-accent-600" : "text-primary-500"
                  }`}
                >
                  {s.value}
                </span>
                <span className="text-sm text-foreground-600">{s.label}</span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}